import { Modal, Button } from "antd";
import { Form, Input, Select, DatePicker, message, InputNumber } from "antd";
import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

class InternalUserDoctorForm extends React.Component {
  state = {
    loading: false,
    visible: false,
    selectedFile: [],
    selectValues: [],
    category: "",
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });

    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  onFinish = (values) => {
    const PatientId = this.props?.id
      ? this.props?.id
      : localStorage.getItem("userid");

    const url = `https://app02.thbglobal.com/v1/internalUserManagement/doctor`;

    let data = {
      name: values.user["name"],
      email: values.user["email"],
      gender: values.user["gender"],
      dob: values["dob"].format("YYYY-MM-DD"),
      profession: values.user["profession"],
      specialization: values.user["specialization"],
      experience: values.user["experience"].toString(),
      address1: values.user["address1"],
      address2: values.user["address2"],
      city: values.user["city"],
      state: values.user["state"],
      pincode: values.user["pincode"],
      country: values.user["country"],
      phone: values.user["phone"],
    };
    this.handleOk();

    axios
      .post(url, data, {
        headers: {
          "x-api-key": `Bearer ${JSON.parse(localStorage.getItem("tokens"))}`,
        },
      })
      .then((res) => {
        if (res.data.type === "Success") {
          // this.props.onMedicalSubmit(res.data.data  );
          message.success("Doctor Created");
          this.props?.id
            ? this.props.fetchInternalUserManagement()
            : console.log("");
          this.setState({ loading: false, visible: false });
        } else {
          this.setState({ loading: false });
          message.warning("Can't Create Doctor");
        }
      })
      .catch((err) => {
        message.error("Error Creating Doctor");
        console.log(err);
      });
  };

  setValue = (val) => {
    this.setState({ category: val });
  };

  render() {
    const { visible, loading } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showModal}>
          Add Doctor
        </Button>

        <Modal
          visible={visible}
          title="Add New Record"
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={800}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
              Return
            </Button>,
          ]}
        >
          <Form
            {...layout}
            name="nest-messages"
            onFinish={(values) => this.onFinish(values)}
            validateMessages={validateMessages}
          >
            <Form.Item
              name={["user", "name"]}
              label="Name"
              rules={[
                {
                  required: true,
                  type: "string",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["user", "email"]}
              label="Email"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "gender"]}
              label="Gender"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select allowClear onChange={this.setValue} required="true">
                <Option value="male">Male</Option>
                <Option value="female">Female</Option>
                <Option value="other">Other</Option>

                {/* <Cascader options={this.values} /> */}
              </Select>
            </Form.Item>

            <Form.Item
              name="dob"
              label="DOB"
              initialValue={moment()}
              rules={[
                {
                  type: "object",
                  required: true,
                  message: "Please select time!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>

            <Form.Item
              name={["user", "profession"]}
              label="Profession"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "specialization"]}
              label="Specialization"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "experience"]}
              label="Experience"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber min={0} />
            </Form.Item>

            <Form.Item
              name={["user", "address1"]}
              label="Address Line 1"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              name={["user", "address2"]}
              label="Address Line 2"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input.TextArea />
            </Form.Item>
            <Form.Item
              name={["user", "city"]}
              label="City"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["user", "state"]}
              label="State"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["user", "pincode"]}
              label="Pincode"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name={["user", "country"]}
              label="Country"
              rules={[
                {
                  type: "string",
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name={["user", "phone"]}
              label="Phone"
              rules={[
                {
                  required: true,
                  message: "Please input your phone number!",
                },
              ]}
            >
              {/* <Input addonBefore="+91" /> */}
              <Input />
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
              <Button type="primary" htmlType="submit">
                {loading && <LoadingOutlined />}
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </>
    );
  }
}

export default InternalUserDoctorForm;
